import { render, staticRenderFns } from "./BigMapKey.vue?vue&type=template&id=6c308308"
import script from "./BigMapKey.vue?vue&type=script&lang=js"
export * from "./BigMapKey.vue?vue&type=script&lang=js"
import style0 from "./BigMapKey.vue?vue&type=style&index=0&id=6c308308&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports